import { RoleListItemsContext } from "@/context/RoleListItemsContext";
import useApi from "@/hooks/useApi";
import React, { useCallback, useEffect, useState } from "react";

export interface RoleListItem {
  id: number;
  name: string;
  description: string;
}

// make this bad boy lazy???
export function RoleListItemsProvider(props: { children: React.ReactNode }) {
  const api = useApi();
  const [customRoles, setCustomRoles] = React.useState<RoleListItem[]>([]);
  const [defaultRoles, setDefaultRoles] = React.useState<RoleListItem[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchCustom = useCallback(async () => {
    try {
      const response = await api.messaging.get("Roles/List");
      const data = await response.json();
      setCustomRoles(Array.isArray(data) ? data : []);
      return data;
    } catch {
      setCustomRoles([]);
    } finally {
      setLoading(false);
    }
  }, [api.messaging]);

  const fetchDefault = useCallback(async () => {
    try {
      const response = await api.messaging.get("Roles/Default");
      const data = await response.json();
      setDefaultRoles(Array.isArray(data) ? data : []);
      return data;
    } catch {
      setDefaultRoles([]);
    } finally {
      setLoading(false);
    }
  }, [api.messaging]);

  useEffect(() => {
    fetchCustom();
    fetchDefault();
  }, [fetchCustom, fetchDefault]);

  function getCustomRoleNameById(roleId: number) {
    return customRoles?.find((x) => x.id === roleId)?.name || "";
  }

  return (
    <RoleListItemsContext.Provider
      value={{
        customRoles: customRoles,
        defaultRoles: defaultRoles,
        roles: defaultRoles?.concat(customRoles),
        getRoleNameById: getCustomRoleNameById,
        loading
      }}
    >
      {props.children}
    </RoleListItemsContext.Provider>
  );
}
